import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { RoleGuardService } from '../auth/services/role.guard';
import { AuthService } from '../auth/services/auth.service';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {
  public isAdmin: boolean;
  public isSuperAdmin: boolean;
  public userName: string;

  constructor(private router: Router,
              private roleGuardService: RoleGuardService,
              private authService: AuthService) { }

  ngOnInit() {
    this.isAdmin = this.roleGuardService.isAuthorized(['Admin']);
    this.isSuperAdmin = this.roleGuardService.isAuthorized(['SuperAdmin']);

    const token = this.authService.getDecodedJwtToken();
    this.userName = token.name;
  }

  backToOdiq(): void {
    this.router.navigate(['auth']);
  }
  goMyAccount(): void {
    this.router.navigate(['admin']);
  }
  goMyOrganisation(): void {
    this.router.navigate(['admin/myorganisation']);
  }
  goOrganisation(): void {
    this.router.navigate(['admin/organisations']);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin.component.ts